import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import ReactGA from "react-ga4";

import Homepage from "./pages/homepage";
import About from "./pages/about";
import ServicesERP from "./pages/servicesERP";
// import ServicesBIReport from "./pages/servicesSuperSet";
import ServicesIT from "./pages/servicesIT";
import ServicesRecruitment from "./pages/servicesRecruitment";
import Articles from "./pages/articles";
import ReadArticle from "./pages/readArticle";
import Contact from "./pages/contact";
import Notfound from "./pages/404";
import MaintenancePage from "./pages/maintenance";

import { TRACKING_ID } from "./data/tracking";
import "./app.css";

function App() {
	const isMaintenanceMode = true;

	useEffect(() => {
		if (TRACKING_ID !== "") {
			ReactGA.initialize(TRACKING_ID);
		}
	}, []);

	return (
		<div className="App">
			{isMaintenanceMode ? (
				<MaintenancePage />
			) : (
				<Routes>
					<Route path="/" element={<Homepage />} />
					<Route path="/about" element={<About />} />
					<Route path="/servicesERP" element={<ServicesERP />} />
					{/* <Route path="/ServicesBIReport" element={<ServicesBIReport />} /> */}
					<Route path="/ServicesIT" element={<ServicesIT />} />
					<Route path="/ServicesRecruitment" element={<ServicesRecruitment />} />
					<Route path="/articles" element={<Articles />} />
					<Route path="/article/:slug" element={<ReadArticle />} />
					<Route path="/contact" element={<Contact />} />
					<Route path="*" element={<Notfound />} />
				</Routes>
			)}
		</div>
	);
}

export default App;
